import { css } from "@emotion/react"
import { colorsCP, fontsCP } from "@mkt/cp/src/styles/Tokens"
import { above } from "@mkt/cp/src/styles/Breakpoints"
import { blueberry } from "@mkt/cp/src/styles/Blueberry"
import { iqHeader } from "@mkt/cp/src/styles/Blueberry/components/header"
import { iqBtn } from "@mkt/cp/src/styles/Blueberry/components/button"
import { iqFooter } from "@mkt/cp/src/styles/Blueberry/components/footer"

export const appLayout = css`
  body {
    background: ${colorsCP["gray-10"]};
  }

  @media (min-width: 1200px) {
    .footer-cp__container,
    .header-cp__container {
        max-width: 1360px;
    }
  }

  ${iqHeader}
  ${iqFooter}

  header:first-of-type {
    position: fixed;
    z-index: 5;
    left: 0;
    top: 0;
    background: ${colorsCP['gray-0']};
    width: 100vw;
    ${iqBtn}

    .header-cp__logged-out-navigation-list-item--active {
      .iq-btn {
        font-family: ${fontsCP['font-secondary']['font-family']};
        font-weight: 700;
        color: ${colorsCP['blue-40']};
      }
    }
  }

  .header-cp__navbar {
    background-color: ${colorsCP['neutral-00']};
    display: flex;
    align-items: center;
  }

  @media screen and (min-width: 720px) {
    .header-cp__logged-out-navigation-link--submenu::before {
      background-color: transparent;
      border-radius: 0px;
      border: 2px solid #7874e6;
      border-left: none;
      border-top: none;
      content: "";
      height: 8px;
      margin-top: -4px;
      position: absolute;
      right: 10px;
      top: 50%;
      transition: transform 0.3s ease, -webkit-transform 0.3s ease;
      width: 8px;
      transform: rotate(45deg);
    }

    .header-cp__logged-out-navigation-link--submenu::after {
      display: none;
    }
  }

  a > div .iq-text {
    color: ${colorsCP['neutral-70']};
  }
`

export const mainContent = css`
  margin-top: 100px;
  background: ${colorsCP["gray-10"]};

  ${above["m"]} {
    margin-top: 107px;
  }

  ${blueberry}
`
